import {
  assessmentScorePillars,
  getAssessmentCategoryScore,
} from "../../form/components/integrity-scores/scoreCategories";
import { getScoreDisplayValue } from "../../formatting/domain-value-manipulation";
import type { Pillars } from "../../types";
import type { Field } from "../tabs/types";

export function buildIntegrityScoreFields(pillars?: Pillars): Array<Field> {
  let index = 0;

  return assessmentScorePillars.flatMap((pillar) =>
    pillar.categories.flatMap((category) => {
      const value = getAssessmentCategoryScore(
        pillars,
        pillar.key,
        category.key,
      );
      const fieldName = `${pillar.label} — ${category.label}`;
      const fields: Array<Field> = [
        {
          name: `${fieldName} — Score`,
          type: "text",
          index: index++,
          value: getScoreDisplayValue(value?.score),
        },
        {
          name: `${fieldName} — Status`,
          type: "text",
          index: index++,
          value: value?.status,
        },
        {
          name: `${fieldName} — Evidence`,
          type: "text",
          index: index++,
          fullLine: true,
          value: value?.explanation,
        },
      ];

      return fields;
    }),
  );
}
